var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"search-wrap"},[_vm._t("items"),_c('li',[_c('a',{staticClass:"btn sub-btn btn-basic-outline",on:{"click":_vm.onClickSearch}},[_c('i',{staticClass:"icon-fux-search m-r-xs"}),_vm._v(_vm._s(_vm.$t('조회')))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }